import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import AttachFile from '@material-ui/icons/AttachFile';
// import PhotoSizeSelectActual from '@material-ui/icons/PhotoSizeSelectActual';

const styles = theme => ({
	attachBtn: {
		// borderColor: theme.palette.action.active,
		borderWidth: 1,
		borderStyle: "solid",
		fontSize: "1.6rem",
		width: 5.25 * theme.spacing.unit,
		height: 5.25 * theme.spacing.unit,
	},
	attachIcon: {
		color: theme.palette.action.active,
	},
	count: {
		marginLeft: 1.5 * theme.spacing.unit,
		color: theme.palette.text.primary,
		fontSize: "1.2em"
	},
});

class UploadButton extends Component {
	// componentDidMount() {
	// }

	render() {
		let {classes, selectFileHandler, count} = this.props;
		let inputId = (Math.random() * 1e+18).toString(36).slice(0, 8);
		// TODO - allow more than images
		return (
			<div>
				<input hidden
					id={inputId}
					accept="image/*"
					type="file"
					multiple
					aria-hidden="true"
					onChange={selectFileHandler}
				/>
				<IconButton
					className={`${classes.attachBtn}`}
					aria-label="attach images"
					ga-on="click"
					ga-event-category="WebApp"
					ga-event-action="Button Pressed"
					ga-event-label="Attachments"
					component="span" 
					color="primary"
					classes={{
						colorPrimary: classes.attachIcon
					}}
					onClick={() => document.getElementById(inputId).click()}>
					<AttachFile />
				</IconButton>
				<span className={classes.count}>{count}</span>
			</div>
		);
	}
}

UploadButton.propTypes = {
	selectFileHandler: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(UploadButton);
